"use client";

import { useEffect, useState, useRef } from "react";
import { Source, SourceResponse } from "./types";

export const useSources = () => {
  const [sources, setSources] = useState<Source[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [newItemId, setNewItemId] = useState<string | null>(null);
  const prevFirstIdRef = useRef<string | null>(null);

  useEffect(() => {
    const fetchSources = async () => {
      try {
        const res = await fetch(
          "https://management-backend.opengpu.network/api/sources",
        );
        const data = (await res.json()) as SourceResponse;

        if (data?.status === "success" && data?.data?.sources) {
          const newSources = data.data.sources.slice(0, 3);
          if (newSources.length > 0) {
            const currentFirstId = newSources[0]._id.$oid;
            if (
              prevFirstIdRef.current !== null &&
              prevFirstIdRef.current !== currentFirstId
            ) {
              setNewItemId(currentFirstId);
              setTimeout(() => setNewItemId(null), 500);
            }
            prevFirstIdRef.current = currentFirstId;
          }
          setSources(newSources);
          setIsFirstLoad(false);
        }
        setIsLoading(false);
      } catch (error) {
        setSources([]);
        setIsLoading(false);
        setIsFirstLoad(false);
      }
    };

    fetchSources();
    const interval = setInterval(fetchSources, 30000);

    return () => clearInterval(interval);
  }, []);

  return { sources, isLoading, isFirstLoad, newItemId };
};
